import { createContext } from 'react'

import type { ConfirmFormValues } from '../../containers/AccountSetup/Confirm/Confirm.Form'
import type { ApolloError } from '@apollo/client'
import type { AccountSetupInfo } from '@shared/graphql'

export type AccountSetupStep =
  | 'WELCOME'
  | 'CONFIRM_DETAILS'
  | 'CONFIRM_ROLE'
  | 'INVITE_AUTH_REP'

export interface AccountSetupContextState {
  /**
   * An error ocurred.
   */
  error?: ApolloError
  /**
   * Loading.
   */
  loading: {
    /**
     * Initial rerouting in progress.
     */
    rerouting: boolean
    /**
     * Is business info processing.
     */
    processing: boolean
  }
  /**
   * Account setup data.
   */
  data: Partial<AccountSetupInfo> & {
    /**
     * Business details.
     */
    businessDetails?: ConfirmFormValues
  }
}

export interface AccountSetupContextActions {
  /**
   * Determine next step based on completed step (determine where to route user).
   */
  completeStep: (step: AccountSetupStep) => void
  /**
   * Set business details.
   */
  setBusinessDetails: (values: ConfirmFormValues) => void
}

export const AccountSetupContext = createContext<
  [AccountSetupContextState, AccountSetupContextActions] | null
>(null)
